import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HTH} from "../HTH";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {HTHGameAssets} from "../HTHGameAssets";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {HTHHelper} from "../utils/HTHHelper";
import {gsap} from "gsap";

export class HTHGameIntroView extends PIXI.Container implements StageLayer{

    private _mainTl:gsap.core.Timeline;
    private _prevSpaceBarSettings: boolean;
    private _blackGraphics:PIXI.Graphics;
    private _spine:PIXI.spine.Spine;
    private _welcomeText :PIXI.Text;
    private _maxWinText:PIXI.Text;
    private _maxWinAmount :PIXI.BitmapText;

    constructor() {
        super();
        this.name = "HTHGameIntroView";
        this.init();
    }

    private init():void {
        this._blackGraphics=new PIXI.Graphics();
        this._blackGraphics.beginFill(0x000000, 1);
        this._blackGraphics.drawRect(0, 0, 725, 616);
        this._blackGraphics.endFill();
        this._blackGraphics.name = "blackGraphics";
        this._blackGraphics.position.set(0, 60);

        this.addChild(this._blackGraphics);


        this._welcomeText = new PIXI.Text("", new PIXI.TextStyle(
            {
                fill: "#ffffff",
                fontFamily: "ARCADECLASSIC",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 50,
                letterSpacing: 5,
            }));
        this._welcomeText.position.set(200,100);
        this.addChild(this._welcomeText);

        this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("BigwinTransition"));
        this._spine.position.set(360, 360);
        this.addChild(this._spine);

        this._maxWinText = new PIXI.Text("MAX WIN:", new PIXI.TextStyle(
            {
                fill: "#FEEB04",
                fontFamily: "ARCADECLASSIC",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 50,
                letterSpacing: 5,
            }));
        this._maxWinText.alpha=0;
        this._maxWinText.position.set(200,360);

        this._maxWinAmount = new PIXI.BitmapText("20   066x", {
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 26
        })
        this._maxWinAmount.name = "capWinWays";
        this._maxWinAmount.alpha = 0;
        this._maxWinAmount.position.set(340, 460);
        this._maxWinAmount.anchor = new PIXI.Point(0.5, 0.5);

        this.addChild(this._maxWinText,this._maxWinAmount);
    }

    public startIntro():void {
        this._mainTl = gsap.timeline({
            onStart:()=>{
                this.interactive = true;
                this._prevSpaceBarSettings = HTH.apiPlugin.settings.get(APISetting.USE_SPACE_TO_SPIN, false);
                HTH.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, false);
                HTH.keypadPlugin.toggleVisibility(false);
            }
        })
        this._mainTl.to(this,{duration:0.1});
        this._mainTl.add(()=>{
            const miniTl:gsap.core.Timeline=gsap.timeline();
            let finalText:string = "Welcome...";
            for(let i=0;i<finalText.length;i++){
                miniTl.add(()=>{
                    this._welcomeText.text+=finalText[i];
                },">+=0.05");
            }
        },0);
        this._mainTl.to([this._maxWinText,this._maxWinAmount],{alpha:1,duration:0.2},0.5)

        this._mainTl.add(HTHHelper.playSpineWithTimeline(this._spine,0,"bw_transition").timeScale(0.75),2.5);
        this._mainTl.to([this._maxWinAmount,this._welcomeText,this._maxWinText,this._blackGraphics],{alpha:0,duration:1.5},"<");
        this._mainTl.add(()=>{
            this.stopIntro();
        })

        this.on('pointerdown', () => {
            this.stopIntro();
        });


    }

    public stopIntro():void {
        this.interactive = false;
        // console.log(this._introTl.totalDuration());
        this._mainTl.totalProgress(1);
        this._mainTl.kill();
        this.destroy({children: true});
        HTH.keypadPlugin.toggleVisibility(true);
        HTH.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, this._prevSpaceBarSettings);
    }
}